import React, { useEffect, useState } from "react";

import "../SinglePackageHeader/SinglePackageHeader.css";

import NewGetQuoteDownloadPopup from "../NewGetQuoteDownloadPopup/NewGetQuoteDownloadPopup";
import { SvgDownload } from "../../utils/svgIcons";
import { PDFDownloadLink } from "@react-pdf/renderer";
import PackagePDF from "./PackagePDF"; // Import the PDF component we created earlier
import { formatDateToYYYYMMDD } from "../../utils/utils";
import { saveAs } from "file-saver";
import { pdf } from "@react-pdf/renderer";
import { showErrorToast } from "../../assets/toastUtils";

const ButtonToDownloadTablePDF = ({
  itemToDownloadID,
  ignoreFromPrint,
  pdfOrientation,
  packageData,
  newUiDownload,
  onSelectedOptionChange,
  pkgDetail,
  imageData,
  userDetails,
  userType,
  logo,
  selectedCategory,
  allPackageHotels,
  calculatePriceWithMarkup,
  markupValue,
  setMarkupValue,
  selectedMealPlan,
}) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [openGetQuotePopup, setOpenGetQuotePopup] = useState(false);
  const [selectedOption, setSelectedOption] = useState("newMarkup");

  // const handleDownload = () => {
  //   const originalData = document.getElementById(itemToDownloadID);
  //   originalData.style.display = "block";

  //   const clonedData = originalData.cloneNode(true);

  //   if (ignoreFromPrint) {
  //     const itemToRemove = clonedData.querySelector(`#${ignoreFromPrint}`);
  //     if (itemToRemove) {
  //       itemToRemove.remove();
  //     }
  //   }

  //   const tempContainer = document.createElement("div");
  //   tempContainer.appendChild(clonedData);

  //   originalData.style.display = "none";
  //   const opt = {
  //     margin: [0.5, 0.5, 0.5, 0.5],
  //     filename: `${packageData?.packageName}.pdf`,
  //     image: { type: "jpeg", quality: 1 },
  //     html2canvas: { scale: 2, letterRendering: true, useCORS: true, allowTaint: true },
  //     jsPDF: {
  //       unit: "in",
  //       format: "a4",
  //       orientation: pdfOrientation || "portrait",
  //     },
  //   };

  //   html2pdf()
  //     .from(tempContainer)
  //     .set(opt)
  //     .toPdf()
  //     .get("pdf")
  //     .then(function (pdf) {

  //     })
  //     .save()
  //     .finally(() => {
  //       originalData.style.display = "none";
  //     });
  //   setShowPopup(false);
  // };

  const handleDownloadHandler = () => {
    setShowPopup(false);
    setOpenGetQuotePopup(true);
  };

  useEffect(() => {
    // Check if token is present in local storage
    const token = localStorage.getItem("token");
    if (token) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  const handleDownloadClick = () => {
    setShowPopup(true); // Show popup on button click
  };

  const handleOptionChange = (option) => {
    setSelectedOption(option);
    onSelectedOptionChange(option);
  };

  const handleDownload = async () => {
    setShowPopup(false);

    const doc = (
      <PackagePDF
        pkgDetail={pkgDetail}
        imageData={imageData}
        logo={logo}
        userDetails={userDetails}
        userType={userType}
        selectedCategory={selectedCategory}
        allPackageHotels={allPackageHotels}
        calculatePriceWithMarkup={calculatePriceWithMarkup}
        selectedOption={selectedOption}
        additionalMarkup={markupValue}
        selectedMealPlan={selectedMealPlan}
      />
    );

    const blob = await pdf(doc).toBlob(); // Convert to blob
    const fileName = `${
      pkgDetail?.packageName || "package"
    }-details-${formatDateToYYYYMMDD(new Date())}-${new Date()
      .toLocaleTimeString("en-GB")
      .replace(/:/g, "-")}.pdf`;

    saveAs(blob, fileName); // Save the file
  };

  return (
    <>
      <div
      //  className="flex flex_direction_col align_items_center"
      >
        {/* <SvgDownload /> */}
        {/* <button
          onClick={isLoggedIn ? handleDownload : handleDownloadHandler}
          // onClick={handleDownloadClick}
          className="flex flex_direction_col align_items_center"
          // style={{ color:"#333",fontWeight:"normal" }}
        >
          <span>
            <SvgDownload color="#009A50" />
          </span>
          <strong
            style={{ color: "#333", fontWeight: "normal" }}
            className="Single_pkg_header_modify "
          >
            Download{" "}
          </strong>{" "}
        </button> */}

        {isLoggedIn ? (
          <button
            //  onClick={handleDownload}
            onClick={() => setShowPopup(true)}
            className="flex flex_direction_col align_items_center"
            style={{ background: "none", border: "none", cursor: "pointer" }}
          >
            <span>
              <SvgDownload color="#009A50" />
            </span>
            <strong
              style={{ color: "#333", fontWeight: "normal" }}
              className="Single_pkg_header_modify"
            >
              Download
            </strong>
          </button>
        ) : (
          // <PDFDownloadLink
          //   document={
          //     <PackagePDF
          //       pkgDetail={pkgDetail}
          //       imageData={imageData}
          //       logo={logo}
          //       userDetails={userDetails}
          //       userType={userType}
          //       selectedCategory={selectedCategory}
          //       allPackageHotels={allPackageHotels}
          //       calculatePriceWithMarkup={calculatePriceWithMarkup}
          //       selectedOption={selectedOption}
          //     />
          //   }
          //   fileName={`${pkgDetail?.packageName || "package"}-details-${formatDateToYYYYMMDD(new Date())}-${new Date().toLocaleTimeString('en-GB').replace(/:/g, '-')}.pdf`}
          //   className="flex flex_direction_col align_items_center"
          //   style={{ textDecoration: "none", color: "inherit" }}
          // >
          //   {({ loading }) => (
          //     <>
          //       <span>
          //         <SvgDownload color="#009A50" />
          //       </span>
          //       <strong
          //         style={{ color: "#333", fontWeight: "normal" }}
          //         className="Single_pkg_header_modify"
          //       >
          //         {loading ? "Preparing.." : "Download"}
          //       </strong>
          //     </>
          //   )}
          // </PDFDownloadLink>
          <button
            onClick={handleDownloadHandler}
            className="flex flex_direction_col align_items_center"
            style={{ background: "none", border: "none", cursor: "pointer" }}
          >
            <span>
              <SvgDownload color="#009A50" />
            </span>
            <strong
              style={{ color: "#333", fontWeight: "normal" }}
              className="Single_pkg_header_modify"
            >
              Download
            </strong>
          </button>
        )}
      </div>

      {showPopup && (
        <div className="select_hotel_popup_overlay">
          <div className="select_hotel_popup_overlay_content">
            <h4>Add Additional Markup</h4>
            {/* <label style={{ marginBottom: "8px " }}>
              <input
                type="radio"
                name="existingMarkup"
                value="existingMarkup"
                checked={selectedOption === "existingMarkup"}
                onChange={() => handleOptionChange("existingMarkup")}
              />
              Keep Existing Markup
            </label> */}
            <label>
              <input
                type="radio"
                name="newMarkup"
                value="newMarkup"
                checked={selectedOption === "newMarkup"}
                onChange={() => handleOptionChange("newMarkup")}
              />
              Add New
            </label>

            {selectedOption === "newMarkup" && (
              <div style={{ marginTop: "10px" }}>
                <label>
                  <input
                    type="number"
                    className="w-full"
                    placeholder="Markup %"
                    value={markupValue}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value < 0) {
                        setMarkupValue(0);
                      } else if (value > 100) {
                        showErrorToast(
                          "Please enter a value between 0 and 100"
                        );
                        return;
                      } else {
                        setMarkupValue(value);
                      }
                    }}
                  />
                </label>
              </div>
            )}

            <div className="flex flex_gap_10 mt-10">
              <button
                disabled={!selectedOption}
                style={
                  !selectedOption
                    ? {
                        background: "#ccc",
                      }
                    : {
                        background: "#EB442D",
                      }
                }
                onClick={isLoggedIn ? handleDownload : handleDownloadHandler}
                className="select_hotel_common_btn w-half"
              >
                Download
              </button>
              <button
                onClick={() => setShowPopup(false)}
                className="select_hotel_cancel_btn w-half"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {openGetQuotePopup && (
        <NewGetQuoteDownloadPopup
          package_id={packageData?.packageId}
          setshowRatePopup={setOpenGetQuotePopup}
          handleDownload={handleDownload}
          packageData={packageData}
        />
      )}
    </>

    // <div
    //   onClick={handleDownload}
    //   // onClick={longPdf ?  handleDownload   :  handleDownloadWithJspdf}

    //   style={{
    //     cursor: "pointer",
    //     display: "flex",
    //     alignItems: "center",
    //     justifyContent: "end",
    //     gap: "5px",
    //   }}
    // >
    //   <svg
    //     xmlns="http://www.w3.org/2000/svg"
    //     width="14"
    //     height="14"
    //     viewBox="0 0 14 14"
    //     fill="none"
    //   >
    //     <path
    //       d="M6.99957 10.1107L3.11068 6.22179L4.19957 5.09401L6.22179 7.11623V0.777344H7.77734V7.11623L9.79957 5.09401L10.8885 6.22179L6.99957 10.1107ZM2.3329 13.2218C1.90512 13.2218 1.53879 13.0693 1.2339 12.7645C0.929012 12.4596 0.776827 12.0935 0.777345 11.6662V9.3329H2.3329V11.6662H11.6662V9.3329H13.2218V11.6662C13.2218 12.094 13.0693 12.4603 12.7645 12.7652C12.4596 13.0701 12.0935 13.2223 11.6662 13.2218H2.3329Z"
    //       fill="#3968ED"
    //     />
    //   </svg>
    //   <span style={{ color: "#3968ED", fontSize: "14px", fontStyle: "normal" }}>
    //     Download
    //   </span>
    // </div>
  );
};

export default ButtonToDownloadTablePDF;

{
  /* {openGetQuotePopup &&
        <GetQuoteDownloadPopup
          package_id={packageData?.packageId}
          setshowRatePopup={setOpenGetQuotePopup}
          handleDownload={handleDownload}
          packageData={packageData}
        />
      } */
}
